import { Controller } from "@hotwired/stimulus"

// Blocks submit when both min and max are filled and min > max (money parsed as pt-BR style).
export default class extends Controller {
  static targets = ["minInput", "maxInput", "errorMessage"]
  static values = { errorMessage: String }

  validate(event) {
    const minRaw = this.minInputTarget?.value?.trim()
    const maxRaw = this.maxInputTarget?.value?.trim()
    if (!minRaw || !maxRaw) {
      this.hideError()
      return true
    }

    const min = this.parseMoney(minRaw)
    const max = this.parseMoney(maxRaw)
    if (min === null || max === null) {
      this.hideError()
      return true
    }

    if (min > max) {
      event.preventDefault()
      this.showError()
      return false
    }

    this.hideError()
    return true
  }

  parseMoney(value) {
    const normalized = value.replace(/\./g, "").replace(",", ".")
    const n = parseFloat(normalized)
    return Number.isFinite(n) ? n : null
  }

  showError() {
    if (this.hasErrorMessageTarget && this.errorMessageValue) {
      this.errorMessageTarget.textContent = this.errorMessageValue
      this.errorMessageTarget.hidden = false
    }
  }

  hideError() {
    if (this.hasErrorMessageTarget) {
      this.errorMessageTarget.textContent = ""
      this.errorMessageTarget.hidden = true
    }
  }
}
